import { Story, StorySection } from '../../services';
import { FeedFollowBehavior } from '../models';

export const isStoryFollowable = ({ settings }: Story) =>
  settings.feedFollowBehavior !== FeedFollowBehavior.MANDATORY &&
  settings.section.some((section) =>
    [StorySection.WEB_FEED, StorySection.MOBILE_FEED].includes(section)
  );
